import { ArrowLeft, Block, ButtonIcon, LabelMedium, useStyletron, } from "@mezo-org/mezo-clay";
import React, { useCallback } from "react";
import useDropdownStore, { DropdownView } from "../../stores/dropdownStore";
const getHeaderTitle = (view) => {
    const titleMap = {
        [DropdownView.RECEIVE]: "Receive",
    };
    return titleMap[view];
};
function NestedViewLayout(props) {
    const { children, ...restProps } = props;
    const currentView = useDropdownStore((state) => state.view);
    const setView = useDropdownStore((state) => state.setView);
    const isNested = useDropdownStore((state) => state.isNestedView());
    const [, theme] = useStyletron();
    const handleOnButtonClick = useCallback(() => {
        setView(DropdownView.ROOT);
    }, [setView]);
    return (React.createElement(Block, { display: "flex", flexDirection: "column", minHeight: "588px", padding: theme.sizing.scale700, paddingTop: 0, ...restProps },
        React.createElement(Block, { display: "flex", alignItems: "center", paddingTop: theme.sizing.scale600, paddingBottom: theme.sizing.scale600, marginBottom: theme.sizing.scale300 },
            React.createElement(ButtonIcon, { onClick: handleOnButtonClick, shape: "circle", size: "small", overrides: {
                    BaseButton: {
                        style: {
                            background: theme.colors.backgroundPrimary,
                            marginRight: isNested ? theme.sizing.scale300 : undefined,
                        },
                    },
                } },
                React.createElement(ArrowLeft, { size: theme.sizing.scale700 })),
            React.createElement(LabelMedium, null, getHeaderTitle(currentView))),
        children));
}
export default NestedViewLayout;
//# sourceMappingURL=NestedViewLayout.js.map